import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth';

const USE_COOKIES = import.meta.env.VITE_ADMIN_AUTH_COOKIES === 'true';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const session = useAuthStore.getState().session;
    if (session) {
      // Cookie mode: session presence is enough. Legacy: check tokenExpiresAt.
      if (USE_COOKIES || (session.tokenExpiresAt && session.tokenExpiresAt > Date.now())) {
        throw redirect({ to: '/dashboard' });
      }
    }
    throw redirect({ to: '/login' });
  },
});
